import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const CashfreeCheckoutPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Extract subsSessionId from query parameters
  const searchParams = new URLSearchParams(location.search);
  const subsSessionId = searchParams.get('subsSessionId')|| "sub_session_nzCix0mqC6j3hlP35Tu1xjOz8qgiIKapo0aUTdZO_F5ET4WvR_pkslRCOcOLNI4_fTe4Ny5FBolF4Px-u8yL9efqjbitS3NOJKO2Mb-0VYfUyhC44WZJK-VqMzqFjxGGvZYpayment";
  const env = searchParams.get('env')|| "sandbox";

  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [paymentMessage, setPaymentMessage] = useState('');

  useEffect(() => {
    let cashfreeScript;

    const initializeCashfree = () => {
      try {
        if (!window.Cashfree) {
          throw new Error('Cashfree SDK not loaded properly');
        }

        const cashfree = window.Cashfree({
          mode: env // Use "production" for live environment
        });

        cashfree
          .subscriptionsCheckout({
            subsSessionId: subsSessionId,
            redirectTarget: "_self"
          })
          .then(function (result) {
            if (result.error) {
              setError(result.error.message);
              setPaymentMessage(result.error.message);
            } else {
              setPaymentMessage('Payment initiated successfully');
            }
            setLoading(false);
          })
          .catch(function (error) {
            console.error("Checkout error:", error);
            setError('Payment initialization failed');
            setLoading(false);
          });
      } catch (err) {
        console.error('Initialization error:', err);
        setError('Failed to initialize payment gateway');
        setLoading(false);
      }
    };

    const loadCashfreeSDK = () => {
      try {
        const existingScript = document.querySelector('script[src*="cashfree"]');
        if (existingScript) {
          existingScript.remove();
        }

        cashfreeScript = document.createElement('script');
        cashfreeScript.src = 'https://sdk.cashfree.com/js/v3/cashfree.js';
        cashfreeScript.async = true;

        cashfreeScript.onload = () => {
          console.log('Cashfree SDK loaded');
          setTimeout(initializeCashfree, 100);
        };

        cashfreeScript.onerror = (error) => {
          console.error('Script loading error:', error);
          setError('Failed to load payment gateway. Please try again.');
          setLoading(false);
        };

        document.body.appendChild(cashfreeScript);
      } catch (err) {
        console.error('Script loading error:', err);
        setError('Failed to load payment gateway');
        setLoading(false);
      }
    };

    if (subsSessionId) {
      loadCashfreeSDK();
    } else {
      setError('Invalid subscription ID');
      setLoading(false);
    }

    return () => {
      if (cashfreeScript && cashfreeScript.parentNode) {
        cashfreeScript.parentNode.removeChild(cashfreeScript);
      }
    };
  }, [subsSessionId]);

  const handleRetry = () => {
    setLoading(true);
    setError(null);
    setPaymentMessage('');
    window.location.reload();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 shadow-md">
        <div className="text-center">
          {loading ? (
            <>
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
              <p className="text-lg">Initializing payment...</p>
            </>
          ) : error ? (
            <>
              <p className="text-red-600 mb-4" id="paymentMessage">{error}</p>
              {paymentMessage && (
                <p className="text-sm text-gray-600 mb-4">{paymentMessage}</p>
              )}
              <div className="space-y-2">
                <button
                  onClick={handleRetry}
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 w-full mb-2"
                >
                  Retry Payment
                </button>
                <button
                  onClick={() => navigate('/')} 
                  className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 w-full"
                >
                  Go Back
                </button>
              </div>
            </>
          ) : (
            <>
              <p className="text-lg">Payment window opened</p>
              {paymentMessage && (
                <p className="text-sm text-green-600 mt-2" id="paymentMessage">{paymentMessage}</p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CashfreeCheckoutPage;
